import React, { useEffect, useState } from "react";
import { Alert, Container } from "reactstrap";
import { showTopbarInsideAction } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import HeaderDefaultToPage from "../../../components/Common/headerDefaultToPage";
import BizinBackend from "../../../helpers/bizin_helper";
import { getClientIp } from "../../../helpers/functions";
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken";

const BI_WS0004 = () => {
  document.title = "Defender | Minha Segurança";
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const csrfToken = useGetCsrfToken();

  const { userProfile, userBusiness } = useSelector((state) => ({
    userProfile: state.login.profile,
    userBusiness: state.login.user
  }));

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showRepeat, setShowRepeat] = useState(false);

  const [regras, setRegras] = useState({});
  const [validations, setValidations] = useState({});
  const [inputs, setInputs] = useState({
    Senha_Atual: "",
    Nova_Senha: "",
    Repetir_Nova_Senha: "",
  });
  const [messageAlert, setMessageAlert] = useState(null);
  const [ip, setIp] = useState("");

  const fetchRules = async () => {
    setLoading(true);
    try {
      const prm = {
        PAR_ID_Usuario: userProfile.ID_Usuario,
        PAR_Cultura_Idioma: userProfile.Cultura_Idioma.trim(),
      };
      const resp = await BizinBackend.executeProcedure(
        prm,
        "FRONT_Workspace_Obter_Parametros_Senha",
        csrfToken,
        userBusiness?.access_token
      );

      const map = {};
      resp.forEach((r) => {
        let valor;
        try {
          valor = JSON.parse(r.Valor);
        } catch {
          valor = isNaN(Number(r.Valor)) ? r.Valor : Number(r.Valor);
        }
        map[r.Chave] = {
          texto:     r.Texto,
          descricao: r.Texto_Info,
          valor,
        };
      });
      setRegras(map);
    } catch (err) {
      console.error("[BI_WS0004] erro ao obter regras:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    
    getClientIp().then((meuIp) => setIp(meuIp));

    fetchRules();
  }, []);

  useEffect(() => {
    const inic = Object.keys(regras).reduce(
      (acc, chave) => ({ ...acc, [chave]: false }),
      {}
    );
    setValidations(inic);
  }, [regras]);

  useEffect(() => {
    const pwd = inputs.Nova_Senha;
    const novo = {};
    Object.entries(regras).forEach(([chave, { valor }]) => {
      if (Array.isArray(valor)) {
        novo[chave] = valor.some((c) => pwd.includes(c));
      } else if (typeof valor === "number") {
        novo[chave] = pwd.length >= valor;
      } else {
        novo[chave] = false;
      }
    });
    setValidations(novo);
  }, [inputs.Nova_Senha, regras]);

  useEffect(() => {
    dispatch(showTopbarInsideAction({}));
  }, [dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (inputs.Nova_Senha !== inputs.Repetir_Nova_Senha) {
      setMessageAlert({ message: "Senhas não coincidem.", color: "danger" });
      return;
    }
    if (!Object.values(validations).every((v) => v)) {
      setMessageAlert({
        message: "Senha não atende os requisitos mínimos.",
        color: "danger",
      });
      return;
    }

    const paramsData = {
      ID_Usuario:      userProfile.ID_Usuario,
      PAR_Atual_Senha: inputs.Senha_Atual,
      PAR_Nova_Senha:  inputs.Nova_Senha,
      PAR_IP:          ip,
    };

    try {
      setLoading(true);
      const resp = await BizinBackend.executeProcedure(
        paramsData,
        "FRONT_Usuario_Atualizar_Senha",
        csrfToken,
        userBusiness?.access_token
      );
      
      if (resp?.[0]?.statusCode === 200) {
        setMessageAlert({
          message: resp?.[0]?.message,
          color: "success",
        });
        setInputs({ Senha_Atual: "", Nova_Senha: "", Repetir_Nova_Senha: "" });
      } else {
        setMessageAlert({
          message:resp?.[0]?.statusCode + ' -  ' + resp?.[0]?.message,
          color: "danger",
        });
      }
    } catch (err) {
      console.error("[BI_WS0004] erro ao atualizar senha:", err);
      setMessageAlert({
        message: "Erro ao conectar com o servidor.",
        color: "danger",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content page-config">
      <Container fluid className="dataTable-custom-primary">
        <HeaderDefaultToPage
          goBackPage={"/BI_WS0002"}
          title={"Minha Segurança"}
        />

        <div className="row content-page my-4">
          <div className="col-lg-4 col-md-5 col-12">
            <div className="bg-white card-content w-100">
              <div className="card-body">
                <h5 className="font-size-20 font-w-600 text-primary-dark mb-3">
                  Redefinir Senha
                </h5>

                <form
                  className="row mt-3 form-update-password form-default-primary"
                  onSubmit={handleSubmit}
                >
                  {messageAlert && (
                    <div className="col-12">
                      <Alert color={messageAlert.color}>
                        {messageAlert.message}
                      </Alert>
                    </div>
                  )}

                  {/* Senha Atual */}
                  <div className="col-12 form-group mb-3 position-relative">
                    <label>Senha Atual</label>
                    <div className="form-control d-flex align-items-center gap-3">
                      <i className="fa-solid fa-lock font-size-20"></i>
                      <input
                        type={showCurrent ? "text" : "password"}
                        placeholder="Senha Atual"
                        value={inputs.Senha_Atual}
                        onChange={(e) =>
                          setInputs((st) => ({
                            ...st,
                            Senha_Atual: e.target.value,
                          }))
                        }
                        style={{ flex: 1 }}
                      />
                      <i
                        className={showCurrent ? "far fa-eye eyeStyle gray_secundary" : "far fa-eye-slash eyeStyle gray_secundary"}
                        onClick={() => setShowCurrent((v) => !v)}                        
                      />
                    </div>
                  </div>

                  {/* Nova Senha */}
                  <div className="col-12 form-group mb-2 position-relative">
                    <label>Nova Senha</label>
                    <div className="form-control d-flex align-items-center gap-3">
                      <i className="fa-solid fa-lock font-size-20"></i>
                      <input
                        type={showNew ? "text" : "password"}
                        placeholder="Nova Senha"
                        value={inputs.Nova_Senha}
                        onChange={(e) =>
                          setInputs((st) => ({
                            ...st,
                            Nova_Senha: e.target.value,
                          }))
                        }
                        style={{ flex: 1 }}
                      />
                      <i
                        className={showNew ? "far fa-eye eyeStyle gray_secundary" : "far fa-eye-slash eyeStyle gray_secundary"}
                        onClick={() => setShowNew((v) => !v)}                        
                      />
                    </div>
                  </div>
                  {/* Lista dinâmica de regras */}
                  <ul className="describe-new-password mb-3">
                    {Object.entries(regras).map(([chave, { texto }]) => (
                      <li
                        key={chave}
                        style={{ color: validations[chave] ? "green" : "red" }}
                      >
                        {texto}
                      </li>
                    ))}
                  </ul>
                  {/* Repetir Nova Senha */}
                  <div className="col-12 form-group mb-3 position-relative">
                    <label>Repetir Nova Senha</label>
                    <div className="form-control d-flex align-items-center gap-3">
                      <i className="fa-solid fa-lock font-size-20"></i>
                      <input
                        type={showRepeat ? "text" : "password"}
                        placeholder="Repita a Nova Senha"
                        value={inputs.Repetir_Nova_Senha}
                        onChange={(e) =>
                          setInputs((st) => ({
                            ...st,
                            Repetir_Nova_Senha: e.target.value,
                          }))
                        }
                        style={{ flex: 1 }}
                      />
                      <i
                        className={showRepeat ? "far fa-eye eyeStyle gray_secundary" : "far fa-eye-slash eyeStyle gray_secundary"}
                        onClick={() => setShowRepeat((v) => !v)}                        
                      />
                    </div>
                  </div>



                  <div className="col-12 d-flex justify-content-end">
                    <button className="btn-link-page" type="submit">
                      Redefinir senha
                    </button>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default BI_WS0004;
